<template>
  <v-container fluid>
    <alert-unsaved-changes v-if="unsavedChanges && edit"></alert-unsaved-changes>
    <v-form>
      <v-row v-if="edit">
        <v-col cols="12">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t('optional-info') }}
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <v-row>
                  <v-col cols="12">
                    <label>Payment Model</label>
                    <p class="label-info">
                      Information about the supported payment models and <br />
                      restrictions that apply to the Equipment.
                    </p>
                    <tiptap-vuetify
                      v-model="optionalEquipment.paymentModel"
                      :placeholder="'Suggested length is 500 characters'"
                      :extensions="extensions"
                      clearable
                    ></tiptap-vuetify>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <label>Pricing</label>
                    <p class="label-info">
                      Information on the price scheme for the Equipment.
                    </p>
                    <tiptap-vuetify
                      v-model="optionalEquipment.pricing"
                      :placeholder="'Suggested length is 500 characters'"
                      :extensions="extensions"
                      clearable
                    ></tiptap-vuetify>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <!-- Buttons -->
      <v-row class="my-5" justify="end">
        <v-btn
          v-if="unsavedChanges && edit"
          @click="cancel"
          outlined
          class="black--text font-weight-bold mx-2"
          rounded
          x-large
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          v-if="unsavedChanges && edit"
          @click="updateEquipmentPricingtInfo"
          depressed
          rounded
          x-large
          color="primary200"
          class="white--text font-weight-bold"
        >
          {{ $t('update') }}
        </v-btn>
        <v-btn
          v-if="!unsavedChanges"
          depressed
          rounded
          x-large
          color="black"
          @click="back"
          outlined
          class="black--text font-weight-bold mx-2"
        >
          <v-icon color="black">$vuetify.icons.back</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn
          v-if="!unsavedChanges"
          depressed
          rounded
          x-large
          color="primary200"
          @click="next"
          class="white--text font-weight-bold"
          >{{ $t('next') }}
          <v-icon color="white">$vuetify.icons.next</v-icon>
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus.js';
import AlertUnsavedChanges from '@/components/shared/helpers/AlertUnsavedChanges';

import {
  TiptapVuetify,
  Bold,
  Italic,
  Underline,
  Strike,
  ListItem,
  BulletList,
  OrderedList,
} from 'tiptap-vuetify';

export default {
  name: 'EquipmentPricingInfo',
  mixins: [util],
  components: { TiptapVuetify, AlertUnsavedChanges },
  data: () => ({
    optionalEquipment: {
      paymentModel: '',
      pricing: '',
    },
    dataLoaded: false,
    unsavedChanges: false,
    initialOptionalEquipment: {},
    status: false,
    initialStatus: {},
    extensions: [Bold, Italic, Underline, Strike, ListItem, BulletList, OrderedList],
  }),
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    published: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    optionalEquipment: {
      deep: true,
      handler() {
        if (!this.dataLoaded) return;
        this.unsavedChanges =
          this.optionalEquipment.paymentModel !== this.initialOptionalEquipment.paymentModel ||
          this.optionalEquipment.pricing !== this.initialOptionalEquipment.pricing;
      },
    },
    published: {
      deep: true,
      handler() {
        if (!this.dataLoaded) return;
        this.unsavedChanges = this.status !== this.published;
      },
    },
  },
  mounted() {
    if (this.edit) {
      this.getEquipmentIdPricingInfo();
    }
  },
  methods: {
    back() {
      this.$emit('tab', 4);
    },
    next() {
      this.$emit('tab', 6);
    },
    getEquipmentIdPricingInfo() {
      EventBus.$emit('waiting', true);
      const id = this.$route.params.id;

      this.axios
        .get(`/api/v1/equipment/${id}`)
        .then(response => {
          console.log('Get Equipment Pricing Info', response.data);

          this.status = response.data.published;
          this.optionalEquipment.paymentModel = response.data.paymentModel;
          this.optionalEquipment.pricing = response.data.pricing;

          this.initialOptionalEquipment = {
            paymentModel: response.data.paymentModel,
            pricing: response.data.pricing,
          };

          this.initialStatus = {
            published: response.data.published,
          };
          this.$emit('status', this.initialStatus.published);

          this.dataLoaded = true;
        })
        .catch(error => {
          console.error('Error fetching equipment data:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    updateEquipmentPricingtInfo() {
      const id = this.$route.params.id;
      const equipmentUpdateData = {
        published: this.published,
        id: id,
        paymentModel: this.optionalEquipment.paymentModel,
        pricing: this.optionalEquipment.pricing,
      };

      this.axios
        .put('api/v1/equipment/pricing-info', equipmentUpdateData)
        .then(response => {
          console.log('Equipment info updated successfully:', response.data);
          EventBus.$emit('snackbar', {
            text: 'Equipment Updated Successfully',
          });

          this.initialStatus = this.status;
          this.unsavedChanges = false;
          this.$emit('updatedChanges', true);

          this.getEquipmentIdPricingInfo();
        })
        .catch(error => {
          console.error('Error updating equipment info:', error);
        });
    },
    cancel() {
      this.getEquipmentIdPricingInfo();
    },
  },
};
</script>
